"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var LanguageSelector_1 = require("components/LanguageSelector");
var component = function (props) { return (React.createElement("div", { className: 'sso-header' },
    React.createElement("div", { className: 'language-selector' },
        React.createElement(LanguageSelector_1.default, { languageCode: props.selectedLanguage, updateUserLanguage: props.fetchLanguage, previewSize: '32x24' })),
    React.createElement("div", null,
        React.createElement("h1", null, (0, translation_1.getLocalization)('sso/header/singleSingOn')),
        React.createElement("hr", { className: 'title' }),
        React.createElement("p", null, (0, translation_1.getLocalization)('sso/header/text'))))); };
exports.default = component;
